/* eslint-disable no-useless-concat */
import React, { Fragment } from "react";
import { styled } from '@mui/material/styles';
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { SecuredNavLink } from "../HOC/CustomComponents/Secured";
import { Typography, Paper, Toolbar, IconButton, Icon } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { gql, useQuery } from "@apollo/client";
import { KeyValuePair } from "../HOC/CustomComponents/KeyValuePair";
import { SHIPMENT_TRANSACTION_TYP_ID } from "./Graphql";
import FullScreenLoading from "../HOC/FunctionComponents/LoadingPages/FullScreenLoading";
import { Globals } from "../HOC/Classes/Globals";
import Grid from "@mui/material/Unstable_Grid2";

const PREFIX = 'ShipmentTransactionTypeView';

const classes = {
  loading: `${PREFIX}-loading`,
  paper: `${PREFIX}-paper`,
  toolbar: `${PREFIX}-toolbar`,
  toolbarIcons: `${PREFIX}-toolbarIcons`,
  iconButton: `${PREFIX}-iconButton`,
  iconColor: `${PREFIX}-iconColor`,
  main: `${PREFIX}-main`,
  field: `${PREFIX}-field`
};

const StyledGrid = styled(Grid)((
  {
    theme
  }
) => ({
  [`& .${classes.loading}`]: {},

  [`& .${classes.paper}`]: {
    padding: theme.spacing(3),
    flexGrow: 1,
  },

  [`& .${classes.toolbar}`]: {
    borderBottom: "1px #ccd1d6 solid",
    backgroundColor: "#f5f7f9",
    width: "100%",
  },

  [`& .${classes.toolbarIcons}`]: {
    flex: "1 1 100%",
    textAlign: "end",
  },

  [`& .${classes.iconButton}`]: {
    borderRadius: "0 4px 4px 0 ",
    boxShadow: "none",
    height: 45,
  },

  [`& .${classes.iconColor}`]: {
    color: theme.palette.success.main,
  },

  [`& .${classes.main}`]: {
    margin: 0,
    width: "100%",
  },

  [`& .${classes.field}`]: {
    width: 260,
    [theme.breakpoints.down("sm")]: {
      width: 170,
    },
  }
}));

const ShipmentTransactionTypeView = (props) => {

  const { t } = useTranslation();
  const shipmentTransactionTypeId = props.match.params.id?.trim();
  const { loading, data } = useQuery(
    gql`
      ${SHIPMENT_TRANSACTION_TYP_ID.query}
    `,
    {
      fetchPolicy: "network-only",
      variables: { id: parseInt(shipmentTransactionTypeId) },
    }
  );

  const user = Globals.user;
  const branchId = data?.shipmentTransactionType?.branch?.id;
  const canAccessBranch = branchId ? user.canAccessBranch(branchId) : true;

  const canEdit =
    user.hasPermission("shipping.shipment_transaction_type.update") &&
    canAccessBranch;

  return (
    <StyledGrid
      container
      justifyContent="center"
      className={classes.mainTracking}
      sx={{ margin: "0", width: "100%" }}
    >
      {loading ? (
        <FullScreenLoading minHeight="25%" />
      ) : (
        <>
          <Fragment>
            <Toolbar className={clsx(classes.toolbar)} variant="regular">
              <Grid
                container
                sx={{ flexWrap: "initial", flexGrow: 1 }}
                alignItems="center"
              >
                <Grid className={classes.field}>
                  <Typography variant="h6">
                    {t(`shipmentTransactionTypesDetails`)}
                  </Typography>
                </Grid>
                <Grid className={classes.toolbarIcons}>
                  <SecuredNavLink
                    permission={canEdit}
                    to={{
                      pathname: `/admin/shipment-transaction-types/${shipmentTransactionTypeId}/edit`,
                    }}
                  >
                    <IconButton color={"primary"} size="large">
                      <Edit fontSize="inherit" />
                    </IconButton>
                  </SecuredNavLink>
                </Grid>
              </Grid>
            </Toolbar>
          </Fragment>
          <Grid
            container
            justifyContent="center"
            sx={{ width: "100%", p: 2, gap: 2 }}
          >
            <Paper container xs={12} className={classes.paper} component={Grid}>
              <KeyValuePair
                title={t("code")}
                value={data?.shipmentTransactionType?.code}
              />
              <KeyValuePair
                title={t("name")}
                value={data?.shipmentTransactionType?.name}
              />
              <KeyValuePair
                title={t("active")}
                value={
                  data?.shipmentTransactionType?.active ? (
                    <Icon className={classes.iconColor}>
                      check_circle_outline
                    </Icon>
                  ) : (
                    <Icon color="error">highlight_off</Icon>
                  )
                }
              />
              <KeyValuePair
                title={t("documentType")}
                value={data?.shipmentTransactionType?.type?.name}
              />
              <KeyValuePair
                title={t("sequence")}
                value={data?.shipmentTransactionType?.sequence?.name}
              />
            </Paper>

            <Paper container xs={12} className={classes.paper} component={Grid}>
              <KeyValuePair
                title={t("branch")}
                value={data?.shipmentTransactionType?.branch?.name}
              />
              <KeyValuePair
                title={t("glAccount")}
                value={data?.shipmentTransactionType?.glAccount?.name}
              />
              <KeyValuePair
                title={t("journalType")}
                value={data?.shipmentTransactionType?.journalType?.name}
              />
              <KeyValuePair
                title={t("subsidiary")}
                value={data?.shipmentTransactionType?.subsidiary?.name}
              />
            </Paper>
          </Grid>
        </>
      )}
    </StyledGrid>
  );
};

export default ShipmentTransactionTypeView;
